// extracted by mini-css-extract-plugin
module.exports = {"Burger":"styles_Burger__1co7N","isOpen":"styles_isOpen__2y3V7","line":"styles_line__2vVAn"};